import { Box, Stack } from "@mui/material";
import { CartButton } from "../cart-button";
import { Logo } from "./logo";
import { MenuButton } from "./menu-button";
import { StickyContainer } from "./sticky-container";
import { TranslationContext } from "../../translation";
import { useScrollDirection } from "../../utilities";
import { useWindowScrollPosition } from "rooks";
import React from "react";
export const StickyHeader = ({ logo, toggleMenu, }) => {
    const { useCart } = React.useContext(TranslationContext);
    const scrollDirection = useScrollDirection(50);
    const { scrollY } = useWindowScrollPosition();
    const show = scrollDirection === "up" && scrollY > 768;
    return (React.createElement(StickyContainer, { show: show },
        React.createElement(Stack, { direction: "row", justifyContent: "space-between" },
            React.createElement(Box, null, useCart && React.createElement(CartButton, { size: "small" })),
            React.createElement(Logo, { logo: logo, isSticky: true }),
            React.createElement(MenuButton, { onClick: toggleMenu }))));
};
//# sourceMappingURL=sticky-header.js.map